/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCertificateValidate200,
  GetApiV1DocumentCertificateValidate401,
  GetApiV1DocumentCertificateValidate404,
  GetApiV1DocumentCertificateValidate500,
  GetApiV1DocumentCertificateValidateQueryParams,
  GetApiV1DocumentCertificateValidateQueryResponse,
} from "../../types/documentCertificateController/GetApiV1DocumentCertificateValidate.ts";
import { certificateIssuedViewModelSchema } from "../certificateIssuedViewModelSchema.ts";

export const getApiV1DocumentCertificateValidateQueryParamsSchema = z
  .object({
    token: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1DocumentCertificateValidateQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCertificateValidate200Schema = z.lazy(
  () => certificateIssuedViewModelSchema,
) as unknown as ToZod<GetApiV1DocumentCertificateValidate200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCertificateValidate401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCertificateValidate401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCertificateValidate404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCertificateValidate404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCertificateValidate500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCertificateValidate500>;

export const getApiV1DocumentCertificateValidateQueryResponseSchema = z.lazy(
  () => getApiV1DocumentCertificateValidate200Schema,
) as unknown as ToZod<GetApiV1DocumentCertificateValidateQueryResponse>;
